/**
 * AX1.Capital — canonical product brand constants.
 *
 * Import from here for user-facing product name, domain, and contact strings.
 * Legacy AX1.Network branding is retired (see brand.md).
 */

/** Full product name with dot separator (legal, headers, evidence packs). */
export const PRODUCT_NAME = 'AX1.Capital';

/** Display name with space separator (prose, titles). */
export const PRODUCT_NAME_DISPLAY = 'AX1 Capital';

/** Short lockup label used beside the icon mark. */
export const PRODUCT_SHORT_NAME = 'Capital';

/** Primary marketing tagline. */
export const PRODUCT_TAGLINE = 'Programmable Governance';

/** Combined title for browser tab / auth screens. */
export const PRODUCT_TITLE = `${PRODUCT_NAME_DISPLAY} — ${PRODUCT_TAGLINE}`;

/** Primary app domain (no protocol). */
export const APP_DOMAIN = 'ax1.capital';

/** Production app origin. */
export const APP_ORIGIN = `https://app.${APP_DOMAIN}`;

/** Documentation subdomain. */
export const DOCS_ORIGIN = `https://docs.${APP_DOMAIN}`;

/** Default contact addresses (override via env where supported). */
export const CONTACT_EMAILS = {
  support: `support@${APP_DOMAIN}`,
  security: `security@${APP_DOMAIN}`,
  compliance: `compliance@${APP_DOMAIN}`,
  sales: `sales@${APP_DOMAIN}`,
  noreply: `noreply@${APP_DOMAIN}`,
} as const;

/** Public static asset paths for default AX1 branding (non white-label). */
export const BRAND_ASSETS = {
  icon: '/AX1_Icon_Logo.svg',
  wordmark: '/AX1.Capital_Logo_Wordmark.svg',
  favicon: '/favicon.svg',
} as const;
